import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-confezione',
  templateUrl: './confezione.component.html',
  styleUrls: ['./confezione.component.scss'],
})
export class ConfezioneComponent {
  @Input() confezione: any;

  iconClasses  = {
     OSP: 'avatar-red',
     USPL: 'avatar-red',
     RRL: 'avatar-red-custom',
     RNRL: 'avatar-red-custom',
     RR: 'avatar-yellow-custom',
     RMR: 'avatar-yellow-custom',
     RNR: 'avatar-yellow-custom',
     SOP: 'avatar-green-custom',
     OTC: 'avatar-green-custom',
     PT: 'avatar-purple-custom',
     C: 'avatar-red',
     A: 'complementary-3-bg-b4 text-white',
     H: 'complementary-3-bg-b4 text-white',
     Cnn: 'd-none',
     N: 'd-none',
     'C-bis': 'avatar-red'


  }


  constructor() {}


// ngOnInit(){
//   this.confezione.descrizioneRimborsabilita ='';
// }

  isCarente() {
    return this.confezione.carente === 1;
  }

  getIconClass(id : string){

    
    return this.iconClasses[id as keyof typeof this.iconClasses];
  }
  
}
